import React, {useEffect, useMemo} from 'react';
import {useDispatch, useSelector} from "react-redux";
import moment from "moment";
import {selectContestsByIds, selectPrizeAssetById} from "../../stores/pickX/pickX.selectors";
import ParlayRenderer from "../ParlayRenderer/ParlayRenderer";
import {FormattedMessage} from "react-intl";
import SportIcon from "../SportIcon/SportIcon";
import {ParlayStatus, PayoutModel} from "../../constants/PickXEnums";
import Currency from "../Currency/Currency";
import pickXApi from "../../stores/pickX/pickX.api";
import _ from "lodash";
import {selectLocale} from "../../stores/account/account.selectors";


const CompletedParlaysAccordionItem = ({parlay, isOpen, onHeaderClick}) => {

    const dispatch = useDispatch();
    const contestIds = useMemo(() => parlay.contestIds, [parlay.contestIds]);
    const contests = useSelector(state => selectContestsByIds(state, contestIds));
    const uniqueSportIds = [...new Set(parlay.SportIds)];
    const isPrizeAsset = parlay.PayoutModel === PayoutModel.Assets;
    const prizeAsset = useSelector(state=>selectPrizeAssetById(state, parlay.PrizeAssetId));
    const locale = useSelector(selectLocale);

    useEffect(()=>{
        if (isPrizeAsset && !prizeAsset)
            dispatch(pickXApi.endpoints.getPrizeAssetById.initiate(parlay.PrizeAssetId, {forceRefetch: true}));
    },[isPrizeAsset]);

    return (
        <div className={"CompletedParlaysAccordionItem " + (isOpen ? "open" : "closed")}>
            <div className="parlayAccordionHeader"
                 onClick={onHeaderClick}>
                <div className={"parlay"}>
                    <div className={`parlayName ${parlay.Status === ParlayStatus.Cancelled ? 'cancelled' : ''}`}>
                        {moment(parlay.DateCreated).format("MMM D")} <FormattedMessage
                        id={`lobbyView.parlayAccordionHeader.${parlay.PayoutModel}`}/>({parlay.ParlayNum})
                    </div>
                    {/*{earliestGame && <div className={"parlayDate"}> @ {moment(earliestGame).format("MMM DD")}</div>}*/}
                </div>
                <div className={"parlayRightHeader"}>
                    <div className="status">
                        {(parlay.PayoutModel === PayoutModel.Pick12 ||
                            parlay.PayoutModel === PayoutModel.Pick16) && uniqueSportIds?.length > 0 ?
                            <SportIcon sportId={uniqueSportIds[0]}/>
                            : <SportIcon sportId={''}/>}
                        {(parlay.PayoutModel === PayoutModel.Exact || parlay.PayoutModel === PayoutModel.Flex) && uniqueSportIds?.length > 0 && uniqueSportIds.map((p) =><SportIcon key={p} sportId={p}/>)}
                        {parlay.isWon && <div className={"parlayWagerPayout gold-gradient-text"}>{!isPrizeAsset ? <Currency className="gold-gradient-text" value={parlay.Payout}/>
                                                                                                                : prizeAsset?.[`Name${_.capitalize(locale)}`]}</div>}
                        <div className={"arrow"}>
                            <i className={`fa-solid ${isOpen ? 'fa-angle-down' : 'fa-angle-right'}`}/>
                        </div>
                    </div>
                </div>
            </div>
            {isOpen && <ParlayRenderer parlay={parlay}
                                       contests={contests}
                                       prizeAsset={prizeAsset}/>}
        </div>
    );
};

export default CompletedParlaysAccordionItem;